import {ReactNode, useState} from "react";
import {css, cx} from "@panda/css";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../types/AuthActionType";
import {ExtendedRegisterCard} from "./auth_card/ExtendedRegisterCard";
import {LoginCard} from "./auth_card/LoginCard";
import {RegisterCard} from "./auth_card/RegisterCard";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    modalTitle: ReactNode | string;
    modalDescription?: ReactNode | string;
    gtmEventData?: () => void;
    variant?: "default" | "extended";
    className?: string;
    wrapperClassName?: string;
}

export const AuthCard = (props: IProps) => {
    const [register, setRegister] = useState(true);

    const onToggleAuthForm = () => {
        setRegister((prev) => !prev);
    };

    const isExtendedVariant = props.variant === "extended";

    return (
        <div className={cx(authCard, props.className)}>
            {register ? (
                isExtendedVariant ? (
                    <ExtendedRegisterCard
                        onAuthSuccess={props.onAuthSuccess}
                        onSwitchToLogin={onToggleAuthForm}
                        userSource={props.userSource}
                        gtmSourceSection={props.gtmSourceSection}
                        title={props.modalTitle}
                        description={props.modalDescription}
                        gtmEventData={props?.gtmEventData}
                        wrapperClassName={props.wrapperClassName}
                    />
                ) : (
                    <RegisterCard
                        onAuthSuccess={props.onAuthSuccess}
                        onSwitchToLogin={onToggleAuthForm}
                        userSource={props.userSource}
                        gtmSourceSection={props.gtmSourceSection}
                        title={props.modalTitle}
                        description={props.modalDescription}
                        gtmEventData={props?.gtmEventData}
                        wrapperClassName={props.wrapperClassName}
                    />
                )
            ) : (
                <LoginCard
                    onAuthSuccess={props.onAuthSuccess}
                    onSwitchToRegister={onToggleAuthForm}
                    userSource={props.userSource}
                    gtmSourceSection={props.gtmSourceSection}
                    wrapperClassName={props.wrapperClassName}
                />
            )}
        </div>
    );
};

const authCard = css({
    width: "100%",

    "@media (min-width: 768px)": {
        width: "456px"
    }
});
import {ReactNode, useState} from "react";
import {css, cx} from "@panda/css";

import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../types/AuthActionType";
import {ExtendedRegisterCard} from "./auth_card/ExtendedRegisterCard";
import {LoginCard} from "./auth_card/LoginCard";
import {RegisterCard} from "./auth_card/RegisterCard";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    modalTitle: ReactNode | string;
    modalDescription?: ReactNode | string;
    gtmEventData?: () => void;
    variant?: "default" | "extended";
    className?: string;
    wrapperClassName?: string;
}

export const AuthCard = (props: IProps) => {
    const [register, setRegister] = useState(true);

    const onToggleAuthForm = () => {
        setRegister((prev) => !prev);
    };

    const isExtendedVariant = props.variant === "extended";

    return (
        <div className={cx(authCard, props.className)}>
            {register ? (
                isExtendedVariant ? (
                    <ExtendedRegisterCard
                        onAuthSuccess={props.onAuthSuccess}
                        onSwitchToLogin={onToggleAuthForm}
                        userSource={props.userSource}
                        gtmSourceSection={props.gtmSourceSection}
                        title={props.modalTitle}
                        description={props.modalDescription}
                        gtmEventData={props?.gtmEventData}
                        wrapperClassName={props.wrapperClassName}
                    />
                ) : (
                    <RegisterCard
                        onAuthSuccess={props.onAuthSuccess}
                        onSwitchToLogin={onToggleAuthForm}
                        userSource={props.userSource}
                        gtmSourceSection={props.gtmSourceSection}
                        title={props.modalTitle}
                        description={props.modalDescription}
                        gtmEventData={props?.gtmEventData}
                        wrapperClassName={props.wrapperClassName}
                    />
                )
            ) : (
                <LoginCard
                    onAuthSuccess={props.onAuthSuccess}
                    onSwitchToRegister={onToggleAuthForm}
                    userSource={props.userSource}
                    gtmSourceSection={props.gtmSourceSection}
                    wrapperClassName={props.wrapperClassName}
                />
            )}
        </div>
    );
};

const authCard = css({
    width: "100%",

    "@media (min-width: 768px)": {
        width: "456px"
    }
});
